export default {
  wizardHeader: {
    height: `4.8rem`,
    lineHeight: `4.8rem`,
    borderBottom: `3px solid #e5e5e5`,
    position: `relative`,
    zIndex: 10,
    backgroundColor: `white`,
  },
  wizardNavItem: {
    fontSize: `1em`,
    fontWeight: `bold`,
    padding: `0 4rem`,
    display: `inline-block`,
  },
  modalClose: {
    position: `absolute`,
    top: `1.5rem`,
    right: `1.5rem`,
    zIndex: 20,
    color: `rgb(62, 62, 62)`,
    textDecoration: `none`,
    fontSize: `1em`,
    fontWeight: `bold`,
    cursor: `pointer`,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: `100%`,
    boxSizing: `border-box`,
  },
  tableContainer: {
    width: `100%`,
    height: `calc(100% - 13rem)`,
    position: `absolute`,
    top: `5rem`,
    backgroundColor: `white`,
    transition: `transform 0.45s ease`,
    overflowY: `auto`,
  },
  uploadContainer: {
    padding: `8rem`,
  },
  dropzoneContent: {
    display: `flex`,
    flexDirection: `column`,
    alignItems: `center`,
    justifyContent: `center`,
    height: `100%`
  },
  messageContainer: {
    position: `absolute`,
    width: `100%`,
    zIndex: 1,
    transition: `transform 0.6s ease`,
    overflow: `hidden`,
    borderTop: `1px solid rgb(214, 214, 214)`,
    backgroundColor: `white`,
  },
  errorContainer: {
    marginTop: `1.5rem`,
    display: `flex`,
    justifyContent: `center`,
    pointerEvents: `all`,
  },
  icon: {
    color: '#999',
    fontSize: '5rem',
    marginBottom: `1.5rem`,
  },
  buttonRow: {
    position: `relative`,
    zIndex: 1,
    height: `5rem`,
    padding: '0 1.8rem',
    display: `flex`,
    alignItems: `center`,
    borderTop: `1px solid #DEDEDE`,
    backgroundColor: `white`
  },
  button: {
    backgroundColor: 'rgb(66, 133, 244)',
    color: '#fff',
    marginTop: `2rem`,
  },
  success: {
    position: `absolute`,
    top: 0,
    left: 0,
    width: `100%`,
    height: `100%`,
    zIndex: 20,
    backgroundColor: `rgb(66, 133, 244)`,
    transition: `transform 0.3s ease`,
  },
  flash: {
    boxSizing: `border-box`,
    position: `absolute`,
    top: 0,
    width: `100%`,
    padding: `1rem`,
    color: `white`,
    transition: `transform 0.3s ease`,
  },
  flashBtn: {
    border: `2px solid`,
    borderRadius: `8px`,
    padding: `0.25rem`,
    fontSize: `0.8em`,
  },
  loadingOverlay: {
    position: `absolute`,
    top: 0,
    left: 0,
    height: `100%`,
    width: `100%`,
    zIndex: 20,
    display: `flex`,
    justifyContent: `center`,
    alignItems: `center`,
    pointerEvents: `none`,
    backgroundColor: `rgba(0, 0, 0, 0.15)`,
    transition: `opacity 0.35s ease`,
  },
};
